import { useTranslation } from "react-i18next";
import ScrollReveal from "./ScrollReveal";

const CTASection = ({ onDemoClick }: { onDemoClick: () => void }) => {
  const { t } = useTranslation();

  return (
    <section id="contact" className="py-8 lg:py-14 gradient-cta relative overflow-hidden">
      <div className="absolute inset-0 blueprint-bg opacity-30" />

      <div className="container mx-auto px-4 text-center relative z-10 space-y-8">
        <ScrollReveal>
          <h2 className="font-display text-4xl lg:text-6xl text-foreground">{t("cta.title")}</h2>
        </ScrollReveal>

        <ScrollReveal delay={0.1}>
          <p className="text-muted-foreground font-body text-lg max-w-2xl mx-auto">
            {t("cta.desc")}{" "}
            <span className="font-mono text-gold font-bold">{t("cta.amount")}</span> {t("cta.descEnd")}
          </p>
        </ScrollReveal>

        <ScrollReveal delay={0.2}>
          <button
            onClick={onDemoClick}
            className="bg-primary text-primary-foreground px-10 py-4 rounded-full font-body font-medium text-lg hover:glow-cyan-strong transition-all"
          >
            {t("cta.button")}
          </button>
        </ScrollReveal>

        <ScrollReveal delay={0.3}>
          <div className="flex flex-wrap justify-center gap-6 text-sm text-muted-foreground font-body">
            <span>{t("cta.noCommitment")}</span>
            <span>{t("cta.fast")}</span>
            <span>{t("cta.audit")}</span>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};

export default CTASection;
